import getFormattedPrice from '@propertypal/shared/src/utils/property/getFormattedPrice';
import puralise from '@propertypal/shared/src/utils/puralise';
import { Filters } from '@propertypal/shared/src/utils/search/getNlpFilters';

export const getTotalFilters = (filters: Filters, includeStyles: boolean) => {
  let total = 0;

  if (includeStyles) {
    if (filters.minPrice) total += 1;
    if (filters.maxPrice) total += 1;
    if (filters.minBeds) total += 1;
    if (filters.maxBeds) total += 1;
    if (filters.styles) total += filters.styles.length;
  }

  if (filters.includeAgreed) total += 1;
  if (filters.includeGone) total += 1;
  if (filters.excludePoa) total += 1;
  if (filters.excludeStudentLettings && filters.category === 'residential' && filters.saleType === 'rent') total += 1;

  if (['residential', 'student'].includes(filters.category || '') && filters.saleType === 'rent') {
    if (filters.furnished) total += 1;
    if (filters.unfurnished) total += 1;
    if (filters.partiallyFurnished) total += 1;
    if (filters.optionalFurnished) total += 1;
  }

  if (filters.heatingType && filters.heatingType.length > 0) total += 1;
  if (filters.garage || filters.largeGarage) total += 1;
  if (filters.tags && filters.tags.length > 0) total += filters.tags.length;
  if (filters.excludeTags && filters.excludeTags.length > 0) total += filters.excludeTags.length;
  if (filters.epc) total += 1;
  if (filters.includePotentialEpc) total += 1;
  if (filters.yearBuilt) total += 1;
  if (filters.broadband) total += 1;
  if (filters.filter && filters.filter.length > 0) total += filters.filter.length;
  if (filters.coOwnership) total += 1;

  return total;
};

const getFilterTitles = (filters: Filters) => {
  const symbol = filters.currency === 'EUR' ? '€' : '£';
  let priceText = 'Price Range';
  let bedsText = 'Bedrooms';
  let stylesText = 'Property Type';
  let moreText = 'More Filters';

  if (filters.minPrice && filters.maxPrice) {
    priceText = `${getFormattedPrice(filters.minPrice, symbol)} - ${getFormattedPrice(filters.maxPrice, symbol)}`;
  } else if (filters.minPrice) {
    priceText = `${getFormattedPrice(filters.minPrice, symbol)} Min`;
  } else if (filters.maxPrice) {
    priceText = `${getFormattedPrice(filters.maxPrice, symbol)} Max`;
  }

  if (filters.minBeds && filters.maxBeds) {
    bedsText = `${filters.minBeds} - ${filters.maxBeds} Beds`;
  } else if (filters.minBeds) {
    bedsText = `${filters.minBeds} ${puralise('Bed', 'Beds', Number(filters.minBeds))} Min`;
  } else if (filters.maxBeds) {
    bedsText = `${filters.maxBeds} ${puralise('Bed', 'Beds', Number(filters.maxBeds))} Max`;
  }

  if (filters.styles && filters.styles.length > 0) {
    stylesText += ` (${filters.styles.length})`;
  }

  const totalMoreFilters = getTotalFilters(filters, false);

  if (totalMoreFilters > 0) {
    moreText += ` (${totalMoreFilters})`;
  }

  return {
    priceText,
    bedsText,
    stylesText,
    moreText,
  };
};

export default getFilterTitles;
